import { Typography } from '@mui/material'
import { IconPopover } from '../atoms/IconPopover'

export const PopoverWhatIsTurnedOff = () => {
  return (
    <IconPopover icon="?">
      <Typography>
        offにすると捕獲通知や異常検知が来なくなります。
        {/* <br />
            <br />
            デバイスのスイッチをオンにして起動メッセージを受け取るとこの値は自動でonになります。 */}
      </Typography>
    </IconPopover>
  )
}
